// Components
import SponsorDisplay from './sponsor-display'
// Types
import type {SponsorshipAd} from '../types/ballot'
// Styles
import styles from './sponsored-footer.module.scss'

interface SponsoredFooterProps {
  ballotId: string
  sponsorshipAd: SponsorshipAd | null
  isSqueezed: boolean
  onPaginate: (direction: number) => void
  isOnlySubcategory?: boolean
  isLastDestination?: boolean
  hasInteracted?: boolean
  isViewingQuestion?: boolean
  isActiveInteractionMode?: boolean
  hasOnlyOneGroup?: boolean
  isLastGroup?: boolean
}

const SponsoredFooter = ({
  ballotId,
  sponsorshipAd,
  isSqueezed,
  onPaginate,
  isOnlySubcategory = false,
  isLastDestination = false,
  hasInteracted = false,
  isViewingQuestion = false,
  isActiveInteractionMode = false,
  hasOnlyOneGroup = false,
  isLastGroup = false,
}: SponsoredFooterProps) => {
  const showDoneButton = isActiveInteractionMode && isViewingQuestion && isOnlySubcategory && isLastDestination
  const showFinishButton = isActiveInteractionMode && isViewingQuestion
    && !isOnlySubcategory && isLastDestination && (hasOnlyOneGroup || isLastGroup)
  const showContinueButton = isActiveInteractionMode && isViewingQuestion
    && !isOnlySubcategory && isLastDestination && !hasOnlyOneGroup && !isLastGroup

  return (
    <footer
      className={`
        ${styles['sponsored-footer']}
        ${isSqueezed ? styles['--is-squeezed'] : ''}
        ${sponsorshipAd ? styles['--has-ad'] : ''}
      `}
    >
      {sponsorshipAd &&
        <SponsorDisplay
          ballotId={ballotId}
          sponsorshipAds={[sponsorshipAd]}
          styleModifiers={['--ad-text-is-to-the-left']}
        />
      }
      <div
        className={`buttons ${styles['__button-group']}`}
      >
        {showDoneButton && (
          <>
            <button
              onClick={() => onPaginate(-1)}
              className='button is-large'
              style={{marginBottom: '0'}}
            >
              ▲
            </button>
            <button
              disabled={!hasInteracted}
              onClick={() => onPaginate(1)}
              className={`button is-large ${styles['__cta-button']}`}
              style={{marginBottom: '0'}}
            >
              Done
            </button>
          </>
        )}
        {showFinishButton && (<>
          <button
            onClick={() => onPaginate(-1)}
            className='button is-large'
            style={{marginBottom: '0'}}
          >
            ▲
          </button>
          <button
            onClick={() => onPaginate(1)}
            className={`button is-large ${styles['__cta-button']}`}
            style={{marginBottom: '0'}}
          >
            Finish
          </button>
        </>)}
        {showContinueButton && (<>
          <button
            onClick={() => onPaginate(-1)}
            className='button is-large'
            style={{marginBottom: '0'}}
          >
            ▲
          </button>
          <button
            onClick={() => onPaginate(1)}
            className={`button is-large ${styles['__cta-button']}`}
            style={{marginBottom: '0'}}
          >
            Continue
          </button>
        </>)}
        {!showDoneButton && !showFinishButton && !showContinueButton && (<>
          <button
            onClick={() => onPaginate(-1)}
            className='button is-large'
            style={{marginBottom: '0'}}
          >
            ▲
          </button>
          <button
            onClick={() => onPaginate(1)}
            className='button is-large'
            style={{marginBottom: '0'}}
          >
            ▼
          </button>
        </>)}
      </div>
    </footer>
  )
}

export default SponsoredFooter
